import React, { useEffect, useState } from "react";
import { ScaleLoader } from "react-spinners";
import { useThemeContext } from "../../../../context/ThemeContext";

interface CustomLoaderProps {
  color?: string;
  width?: number;
  height?: number;
  radius?: number;
  margin?: number;
}

const CustomLoader: React.FC<CustomLoaderProps> = ({
  width = 4,
  height = 30,
  radius = 2,
  margin = 2,
  color,
}) => {
  const { theme } = useThemeContext();
  const [customColor, setCustomColor] = useState("#C435C8");

  useEffect(() => {
    if (theme === "dark") {
      setCustomColor("#DBE3F8");
    } else {
      setCustomColor("#C435C8");
    }
  }, [theme]);

  return (
    <ScaleLoader
      color={color ? color : customColor}
      height={height}
      width={width}
      radius={radius}
      margin={margin}
    />
  );
};

export default CustomLoader;
